import { handleActions } from 'redux-actions';
import { actions } from './actions';

export { actions };
export { sagas } from './sagas';

const defaultState = {};

export const reducer = handleActions(
  {
    [actions.setDismissed]: (state, { payload }) => ({
      ...state,
      [payload]: true,
    }),
  },
  defaultState
);
